import { fetch } from '@atlassian/eoc-fetch';

import { type IntegrationPatchPayload } from '../../../common/types/configured-integrations';
import { type IIntegrationValues } from '../../../common/types/integration-detail';
import { UrlHelper } from '../../../common/utils/url-helper';
import { type ConfiguredIntegrationsResource } from '../resources/types';

import { LIMIT } from './constants';
import { type GetConfiguredIntegrationsResponse } from './types';

const getIntegrations = async (
	query: Record<string, string>,
	pathParamTeamId?: string | null,
): Promise<ConfiguredIntegrationsResource> => {
	const page = parseInt(query['page']) || 1;
	const offset = (page - 1) * LIMIT;
	const queryParams = query
		? {
				teamId: pathParamTeamId ?? query.teamId,
				group: query.group,
				keyword: query.keyword,
				status: query.status,
			}
		: {};

	return fetch<GetConfiguredIntegrationsResponse>(
		UrlHelper('/v3/integrations/unified', {
			...queryParams,
			offset: offset.toString(), // UrlHelper omits 0 as number since it is a falsy value
			limit: LIMIT,
		}),
	).then((response) => ({
		data: response.data.integrations,
		pageCount: Math.ceil(response.data.count / LIMIT),
		itemCount: response.data.count,
		platformTeamId: response.data.platformTeamId,
	}));
};

const patchIntegration = async (
	integrationId: string,
	integrationType: string,
	body: IntegrationPatchPayload,
	teamId?: string,
): Promise<IIntegrationValues> =>
	fetch<{ data: IIntegrationValues }>(
		UrlHelper(`/v3/integrations/unified/${integrationId}`, {
			type: integrationType,
			teamId,
		}),
		{
			method: 'PATCH',
			body,
		},
	).then((response) => response.data);

const deleteIntegration = async (integrationId: string, integrationType: string, teamId?: string) =>
	fetch(
		UrlHelper(`/v3/integrations/unified/${integrationId}`, {
			type: integrationType,
			teamId,
		}),
		{
			method: 'DELETE',
			responseType: 'headers',
		},
	);

export default {
	getIntegrations,
	patchIntegration,
	deleteIntegration,
};
